module.exports = __webpack_public_path__ + "img/oocl.0d02f153.jpg";